import React from "react";
import { IoIosCloseCircle } from "react-icons/io";

const ConfirmBrandModal = ({ show, onHide, onConfirm, carId }) => {
  if (!show) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h3 style={styles.title}>Confirm Deletion</h3>
          <button onClick={onHide} style={styles.closeButton}>
            <IoIosCloseCircle size={25} />
          </button>
        </div>
        <div style={styles.body}>
          <p>
            Are you sure you want to delete this Brand? All Products Associated
            with this prand will nologer have a brand and they will never be
            searched using brand Again. This action cannot be undone. If
            possible, please edit this brand instead of deleting it.
          </p>
        </div>
        <div style={styles.footer}>
          <button onClick={onHide} style={styles.cancelButton}>
            Cancel
          </button>
          <button onClick={() => onConfirm(carId)} style={styles.confirmButton}>
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    width: "400px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  title: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "bold",
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#888",
  },
  body: {
    marginBottom: "20px",
    fontSize: "16px",
    color: "#333",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  cancelButton: {
    backgroundColor: "#f0f0f0",
    border: "1px solid #ccc",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
  confirmButton: {
    backgroundColor: "red",
    color: "#fff",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
  },
};

export default ConfirmBrandModal;
